export default __webpack_public_path__ + "static/media/photo_placeholder.764b1ca1.jpg";